<span class="form-field">
  <p-password class="password-input" [placeholder]="placeholder()" [formControl]="control()" [toggleMask]="true"
    [feedback]="false" (keyup)="keyupHandler()($event)"
    styleClass="p-password p-component p-inputwrapper p-input-icon-right"></p-password>
  @if (hasHint) {
  <p class="hint-text">{{ hint() }}</p>
  }
</span>